import { Link } from "react-router-dom";
import { Logo } from "@/components/common/Logo";

export default function AuthShell({ children, wide }) {
  return (
    <div className="min-h-screen lg:grid lg:grid-cols-[1fr_minmax(0,1.1fr)]">
      <aside className="hidden lg:block relative overflow-hidden">
        <img src="/images/skinlovers-hero.jpg" alt="Skin Lovers Professional" className="absolute inset-0 w-full h-full object-cover object-[30%_center] scale-105 animate-[fade-up_1.4s_ease-out_both]" />
        <div className="absolute inset-0 bg-gradient-to-t from-noir via-noir/60 to-noir/20" />
        <div className="absolute inset-0 bg-gradient-to-r from-transparent to-noir/80" />
        <div className="absolute bottom-14 left-12 right-12 text-white animate-fade-up" style={{ animationDelay: "300ms" }}>
          <Logo variant="bianco" size="h-8" />
          <p data-testid="auth-headline" className="font-serif text-6xl font-light mt-6 leading-[1.02] max-w-lg">Natural Antiage<br /><em className="text-gold-gradient">is better.</em></p>
          <div className="gold-line w-40 mt-8" />
          <p data-testid="auth-claim" className="mt-6 text-sm text-white/80 leading-relaxed max-w-md">My Skin Lovers è l'app riservata ai centri Skin Lovers Professional: protocolli anti-age non invasivi, documenti, contenuti social, ordini e assistenza in un unico posto.</p>
        </div>
      </aside>
      <section className="relative flex flex-col min-h-screen overflow-hidden">
        <div className="pointer-events-none absolute -top-24 -right-24 w-80 h-80 rounded-full bg-gold/10 blur-3xl animate-float" />
        <div className="relative px-6 sm:px-12 pt-8"><Link to="/accedi"><Logo size="h-7 sm:h-8" /></Link></div>
        <div className="lg:hidden relative mx-6 sm:mx-12 mt-8 h-56 rounded-2xl overflow-hidden border border-gold/20">
          <img src="/images/skinlovers-hero.jpg" alt="Skin Lovers Professional" className="absolute inset-0 w-full h-full object-cover object-[30%_center]" />
          <div className="absolute inset-0 bg-gradient-to-t from-noir via-noir/40 to-transparent" />
          <div className="absolute bottom-4 left-5 right-5">
            <p data-testid="auth-headline-mobile" className="font-serif text-4xl font-light leading-[1.02] text-white">Natural Antiage <em className="text-gold-gradient">is better.</em></p>
            <p className="mt-2 text-xs text-white/80 leading-relaxed">L'app riservata ai centri Skin Lovers Professional.</p>
          </div>
        </div>
        <div className={`relative flex-1 w-full mx-auto px-6 sm:px-12 py-12 ${wide ? "max-w-2xl" : "max-w-md"} flex flex-col justify-center animate-page-in`}>
          {children}
        </div>
        <p className="relative px-6 sm:px-12 pb-6 text-[11px] text-warm-text tracking-[0.12em] uppercase">© {new Date().getFullYear()} Skin Lovers Professional</p>
      </section>
    </div>
  );
}
